import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import { useTranslation } from 'react-i18next';
import useConfig from '../hooks/useConfig';
import useGetVehicle from '../hooks/useGetVehicle';
import shareIsAvailable from '../utils/shareIsAvailable';
import AddToAnyButton from './AddToAnyButton';

const ShareVehicleButton = ({ className }) => {
  const { copies } = useConfig();
  const { vehicle } = useGetVehicle();
  const { t } = useTranslation('general');

  // this fix ssr crashing
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, 7500);
  }, []);

  if (!visible) return null;

  const canShare = shareIsAvailable();

  function share() {
    navigator.share({
      text: `${vehicle.brand} ${vehicle.model} ${vehicle.year}`,
      title: copies.title,
      url: window.location.href,
    });
  }

  return (
    <div>
      {canShare ? (
        <Button
          id="shareButton"
          startIcon={<ShareIcon />}
          size="large"
          variant="contained"
          className={className}
          onClick={share}
        >
          {t('Share')}
        </Button>
      ) : (
        <AddToAnyButton />
      )}
    </div>
  );
};

ShareVehicleButton.propTypes = {
  className: PropTypes.string,
};

ShareVehicleButton.defaultProps = {
  className: '',
};

export default ShareVehicleButton;
